export default __webpack_public_path__ + "static/media/P545_RoHS.8b4b4e19.pdf";